import { StorageProvider } from "../../../contexts/storage/storage-provider";
import { ProgramScheduleTable } from "../shared/ProgramScheduleTable";
import { RiverDischargesTable } from "../shared/RiverDischargesTable";

const Container: React.FC = () => {
  return (
    <ProgramScheduleTable title="Entregas">
      <RiverDischargesTable />
    </ProgramScheduleTable>
  );
};

const Pipelines: React.FC = () => {
  return (
    <StorageProvider>
      <Container />
    </StorageProvider>
  );
};

export default Pipelines;
